const queueItemStatuses = {
  shipped: 'shipped',
  skipped: 'skipped',
  free: 'free',
  product: 'product',
  locked: 'locked',
  empty: 'empty',
  redeemed: 'redeemed',
  paused: 'paused',
  unavailable: 'unavailable',
} as const


export type QueueItemStatus = keyof typeof queueItemStatuses

export default queueItemStatuses
